const SkipLink = () => (
  <a
    href="#main-content"
    className="sr-only fixed left-4 top-4 z-[100] rounded-full bg-ink px-5 py-3 font-semibold text-canvas focus:not-sr-only focus:outline-none focus:ring-4 focus:ring-accent/50"
  >
    Skip to main content
  </a>
);

export default SkipLink;
